import axios from "axios";
import QS from "qs";

// 封装get方法
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 封装post方法
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 本地用的假数据方法
export function local(data, timeout = 0) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve({
        code: 1,
        data: data
      });
    }, timeout);
  });
}
